"use client";

import ThemedCollectionGrid from "@components/create-swag/themed-collection/themed-collection-grid";
import { useStoreContext } from "@components/store/provider";
import styles from "./main.module.scss";

const ThemedCollectionsWidget = () => {
  const { themeCollectionItems } = useStoreContext();
  const themeCollection = themeCollectionItems?.[0];
  if (!themeCollection) return null;
  return (
    <section className={styles.gridCollectionWrapper} aria-labelledby="grid-collection-heading">
      <div className={styles.headingBlock} id="grid-collection-heading">
        <h2 className={styles.blockTitle}>Featured Themed Collections</h2>
      </div>

      <ThemedCollectionGrid collection={themeCollection} />
    </section>
  );
};

export default ThemedCollectionsWidget;
